import { render, staticRenderFns } from "./FavoritesUser.vue?vue&type=template&id=98850e98"
import script from "./FavoritesUser.vue?vue&type=script&lang=js"
export * from "./FavoritesUser.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports